import { watchAuth } from './ducks/auth/sagas';
import { watchApp } from './ducks/app/sagas';

const watchers = [
    watchAuth,
    watchApp,
];

export default watchers;